interface RangeSelectorProps {
  value: '7d' | '30d' | '90d';
  onChange: (value: '7d' | '30d' | '90d') => void;
}

export function RangeSelector({ value, onChange }: RangeSelectorProps) {
  const options: Array<{ value: '7d' | '30d' | '90d'; label: string }> = [
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' },
    { value: '90d', label: '90 Days' },
  ];

  return (
    <div className="inline-flex rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-1">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`
            px-4 py-1.5 text-sm font-medium rounded-md transition-colors
            ${
              value === option.value
                ? 'bg-blue-600 text-white'
                : 'text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200'
            }
          `}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
